const rescueOptions = [{ id: 'con_rescate', label: 'Con Rescate', value: 'si' }, { id: 'sin_rescate', label: 'Sin Rescate', value: 'no' }]
export default rescueOptions